import { Helmet } from "react-helmet-async";

export default function ChildrenPrivacyNotice() {
  return (
    <div className="min-h-screen bg-background p-6 max-w-3xl mx-auto prose prose-invert">
      <Helmet>
        <title>Teen Privacy Notice | HeirWise</title>
        <meta
          name="description"
          content="How HeirWise collects, uses, and protects data about teen learners aged 13 and older."
        />
      </Helmet>
      <h1>Teen Privacy Notice</h1>
      <p className="text-muted-foreground">Last updated: September 23, 2026</p>

      <h2>Who can use HeirWise</h2>
      <p>
        HeirWise is for learners aged 13 and older. We do not knowingly create accounts for, or
        collect personal information from, anyone under 13. If we learn that an account belongs to
        someone under 13, we will close the account and take appropriate steps to delete the associated personal information.
      </p>

      <h2>What we collect</h2>
      <p>
        We may collect a display name, age range, household relationship, lesson and module activity,
        assessment responses, progress, learning evidence, competency state, rewards, and product
        interactions. We do not require a teen learner's phone number or precise location.
      </p>

      <h2>How we use it</h2>
      <p>
        We use this information to provide lessons, adapt learning, assess understanding, surface
        review topics, maintain progress, and create evidence-safe parent-facing summaries. Selected
        service providers may process limited educational context to support these features. We do not
        intentionally send learner names, parent names, email addresses, or household identifiers when
        educational context is sufficient.
      </p>

      <h2>Parental rights</h2>
      <p>
        Parents and guardians can export or delete an eligible teen learner profile, or manage
        permission, from <a href="/parent/privacy">Family Privacy Controls</a>. Limited audit records
        and anonymized aggregate statistics may remain where reasonably necessary, as described in our
        <a href="/privacy-policy"> Privacy Policy</a>.
      </p>

      <h2>Contact</h2>
      <p>For privacy questions, contact founder@steenventures.com.</p>
    </div>
  );
}
